import React, { useState } from "react";
import "antd/dist/antd.css";
import styles from "./Home.module.css";
import { Row, Col, Card, Typography, Spin, Tooltip, Table } from "antd";
import { CSVLink } from "react-csv";
import { CloudDownloadOutlined } from "@ant-design/icons";
const { Text, Title } = Typography;

export const AdminSection = ({ role }) => {
  const data = "hi";
  const [loading, setLoading] = useState(false);
  return (
    <>
      <div>
        <Row gutter={16}>
          <Col className="gutter-row" span={7}></Col>
          <Col span={8}>
            <Card
              title="Research Team "
              size="small"
              extra={
                <Row>
                  <Col className="gutter-row" span={2}>
                    {" "}
                    <div>
                      {loading ? (
                        <div>
                          <Spin size="small" />
                        </div>
                      ) : (
                        <Tooltip
                          placement="topRight"
                          title="Download Status Report"
                          arrowPointAtCenter
                        >
                          <CSVLink
                            filename={"Status Report.csv"}
                            data={[]}
                            className="btn btn-primary"
                          >
                            <CloudDownloadOutlined
                              style={{ fontSize: "29px" }}
                            />
                          </CSVLink>
                        </Tooltip>
                      )}
                    </div>
                  </Col>
                </Row>
              }
              headStyle={{ backgroundColor: "#F0F8FF", border: 0 }}
            >
              <Table
                rowKey="id"
                size="small"
                bordered
                scroll={{ x: 400, y: 900 }}
                style={{ margin: "2px" }}
                dataSource={[]}
                columns={[
                  {
                    title: "Name",
                    dataIndex: "name",
                    key: "name",
                    sorter: (a, b) =>
                      a.name ? a.name.localeCompare(b.name) : 1,
                    fixed: "left",
                    width: "70%",
                  },
                  {
                    title: "App assigned",
                    dataIndex: "appAssigned",
                    key: "appAssigned",
                    sorter: (a, b) =>
                      a.appAssigned
                        ? a.appAssigned.localeCompare(b.appAssigned)
                        : 1,
                    fixed: "left",
                    width: "30%",
                  },
                ]}
                loading={loading}
                pagination={{
                  pageSizeOptions: ["10", "30", "60", "100", "1000"],
                  defaultPageSize: "50",
                  showSizeChanger: true,
                }}
              />
            </Card>
          </Col>
        </Row>
      </div>
      <div>
        <Row gutter={16}>
          <Col className="gutter-row" span={1}></Col>
          <Col span={22}>
            <Card
              title="Apps in Queue for Research"
              size="small"
              extra={
                <Row>
                  <Col className="gutter-row" span={2}>
                    {" "}
                    <div>
                      {loading ? (
                        <div>
                          <Spin size="small" />
                        </div>
                      ) : (
                        <Tooltip
                          placement="topRight"
                          title="Download Status Report"
                          arrowPointAtCenter
                        >
                          <CSVLink
                            filename={"Status Report.csv"}
                            data={[]}
                            className="btn btn-primary"
                          >
                            <CloudDownloadOutlined
                              style={{ fontSize: "29px" }}
                            />
                          </CSVLink>
                        </Tooltip>
                      )}
                    </div>
                  </Col>
                </Row>
              }
              headStyle={{ backgroundColor: "#F0F8FF", border: 0 }}
            >
              <Table
                rowKey="id"
                size="small"
                bordered
                scroll={{ x: 400, y: 900 }}
                style={{ margin: "2px" }}
                dataSource={[]}
                columns={[
                  {
                    title: "Name",
                    dataIndex: "name",
                    key: "name",
                    sorter: (a, b) =>
                      a.name ? a.name.localeCompare(b.name) : 1,
                    fixed: "left",
                    width: "40%",
                  },
                  {
                    title: "Category",
                    dataIndex: "category",
                    key: "category",
                    sorter: (a, b) =>
                      a.category ? a.category.localeCompare(b.category) : 1,
                    fixed: "left",
                    width: "30%",
                  },
                  {
                    title: "Research Link",
                    dataIndex: "researchLink",
                    key: "researchLink",
                    sorter: (a, b) =>
                      a.researchLink
                        ? a.researchLink.localeCompare(b.researchLink)
                        : 1,
                    fixed: "left",
                    width: "30%",
                  },
                ]}
                loading={loading}
                pagination={{
                  pageSizeOptions: ["10", "30", "60", "100", "1000"],
                  defaultPageSize: "50",
                  showSizeChanger: true,
                }}
              />
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};
